import { FC } from 'react';

// Third party
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

// Components
import { BaseLink, BaseCheckbox } from '@mgm/common/components/base';

// Types
import { NavLink } from 'react-router-dom';
import { TLoginActions } from '../type';

const LoginActions: FC<TLoginActions> = ({ rememberMe, setRemember }) => {
  const { t } = useTranslation(['welcome']);
  const handleClick = () => {
    setRemember(!rememberMe);
  };

  return (
    <Grid container>
      <Grid item>
        <FormControlLabel
          sx={{ color: 'text.secondary' }}
          componentsProps={{
            typography: { fontSize: '14px' },
          }}
          control={<BaseCheckbox handleClick={handleClick} value={rememberMe} />}
          label={t('rememberMe')}
        />
      </Grid>
      <Grid item xs className="align-center justify-end">
        <BaseLink to="/forgot" NavLinkComponent={NavLink}>
          {t('forgotPassword')}
        </BaseLink>
      </Grid>
    </Grid>
  );
};

export default LoginActions;
